export interface IItemDto {
  id: string;
  itemName: string;
  plans: IItemPlanDto[];
  assets: IAssetDto[];
  planAssets: IPlanAssetDto[];
}

export interface IItemPlanDto {
  id: string;
  planName: string;
  planDescription: string;
  planPrice: number;
  planPriceCurrency: number;
  stripeId: string;
  displayOrder: number;
}

export interface IAssetDto {
  assetId: string;
  assetName: string;
  assetDescription: string;
  assetType: EAssetType;
}

export interface IPlanAssetDto {
  planId: string;
  assetId: string;
  assetType: EAssetType;
  assetQty: number;
  extraLabel?: string;
}

export enum EAssetType {
  unknown = 0,
  upto = 1,
  yesNo = 2,
  gb = 3
}
